// extracted by css-extract-rspack-plugin
export default {"root":"PZ2hm","primary":"EXlUT","white":"Ch7YX","onlyIcon":"GsIFO","circular":"jzPic","icon":"k1gnl","hidden":"ToP24"};